export const DATE_FORMAT = "dd.MM.yyyy";
export const TIME_FORMAT = "HH:mm";